import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {Link, useSearchParams, useNavigate} from "react-router-dom";
import {Pagination} from "page/util/Pagination";
import {formatBusinessNumber, formatDate, formatPhoneNumber} from "page/util/helpers";

function Main() {
    const [content, setContent] = useState(null);

    const requestSearch = () => {
        axios.get(`/admin/certs`)
            .then((res) => {
                setContent(res.data);
            });
    }

    const requestDelete = (certificateType) => {
        axios.delete(`/admin/certs/${certificateType}`)
            .then((res) => {
                alert("삭제되었습니다.");
                window.location.reload();
            });
    }

    useEffect(() => {
        requestSearch();
    }, []);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">인증서관리</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">

                                    <div className="card">
                                        <div className="card-tools" style={{marginTop: '40px'}}>
                                            <div className="form-group row" style={{float: "right"}}>

                                            </div>
                                        </div>

                                        <div className="card-body table-responsive p-0" style={{marginTop: '20px'}}>
                                            <table className="table table-hover text-nowrap"
                                                   style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>사용처</th>
                                                    <th>이름</th>
                                                    <th>등록일</th>
                                                    <th>삭제</th>
                                                    <th>등록</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td>홈택스,4대보험</td>
                                                    <td>
                                                        <span style={{ color: content?.homeTax?.name ? 'blue' : 'red' }}>
                                                            {content?.homeTax?.name || '미등록'}
                                                        </span>
                                                    </td>
                                                    <td>{formatDate(content?.homeTax?.createdAt)}</td>
                                                    <td>
                                                        {
                                                            content?.homeTax !== null
                                                                ? (
                                                                    <button type="button"
                                                                            className="btn btn-outline-danger"
                                                                            onClick={() => requestDelete('HOME_TAX')}>
                                                                        삭제
                                                                    </button>
                                                                )
                                                                : (<span></span>)
                                                        }
                                                    </td>
                                                    <td>
                                                        <button type="button"
                                                                className="btn btn-outline-primary"
                                                                onClick={() => window.open("/infotech/cert.html?use=hometax", "_blank")}>
                                                            등록
                                                        </button>
                                                    </td>
                                                </tr>
                                                    <tr>
                                                        <td>건강보험전용(4대보험)</td>
                                                        <td>
                                                            <span style={{ color: content?.health?.name ? 'blue' : 'red' }}>
                                                            {content?.health?.name || '미등록'}
                                                        </span>
                                                        </td>
                                                        <td>{formatDate(content?.health?.createdAt)}</td>
                                                        <td>
                                                            {
                                                                content?.health !== null
                                                                    ? (
                                                                        <button type="button"
                                                                                className="btn btn-outline-danger"
                                                                                onClick={() => requestDelete('HEALTH')}>
                                                                            삭제
                                                                        </button>
                                                                    )
                                                                    : (<span></span>)
                                                            }

                                                        </td>
                                                        <td>
                                                            <button type="button"
                                                                    className="btn btn-outline-primary"
                                                                    onClick={() => window.open("/infotech/cert.html?use=health", "_blank")}>
                                                                등록
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}

export default Main;
